<template>
    <div class="talent" :class="{'talentDark':isDark}">
        <div class="back">
            <div class="blur">
                <div :class="{seize: falg}"></div>
                <div class="header" :class="{offsetTop: falg}">
                    <span>
                        <van-icon  @click="returnBack(2)" name="arrow-left" />
                        <van-icon  @click="returnBack(1)" name="cross" />
                    </span>
                    <span>Top达人榜</span>
                    <span></span>
                </div>
                <div class="body" ref="topRef">
                    <div class="tabs">
                        <div class="item" v-for="(item, index) in tabsList" :key="index" @click="active = item.key,activeLabel = labelList[active][0],getList()" :class="{active: item.key == active}">
                            {{item.name}}
                        </div>
                    </div>
                    <div class="label">
                        <div class="left">
                            <span @click="show = true">{{activeLabel.text}}<van-icon name="arrow-down" /></span>
                        </div>
                        <div class="right">
                            <span :class="{btnActive: sport_id == 0}" @click="sport_id = 0,getList()">全部</span>
                            <span :class="{btnActive: sport_id == 1}" @click="sport_id = 1,getList()">足球</span>
                            <span :class="{btnActive: sport_id == 2}" @click="sport_id = 2,getList()">篮球</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content" v-if="arr">
                <div class="ranking">
                    <div class="two"  @click="goUserPage(arr[1].user_info.uid)">
                        <div class="img">
                            <div class="boxImg">
                                <img :src="arr[1].user_info.avatar" alt="">
                            </div>
                            <div class="phone">
                                <img :src="require('../../assets/img/talent/no2phone.png')" alt="">
                            </div>
                            <div class="buyCount" v-if="arr[1].buy_count > 0">
                                {{arr[1].buy_count}}
                            </div>
                        </div>
                        <div class="text">
                            <p>{{arr[1].user_info.nickname}}</p>
                            <p>{{arr[1].text}}</p>
                        </div>
                        <div class="follow">
                            <span @click.stop="follow(arr[1].user_info.isFollowed, arr[2].user_info.uid)" :class="{followGuan:arr[1].user_info.isFollowed && arr[1].user_info.isFollowed  != 0}">{{!arr[1].user_info.isFollowed || arr[1].user_info.isFollowed == 0 ? '关注' : '已关注'}}</span>
                        </div>
                    </div>
                    <div class="one"  @click="goUserPage(arr[0].user_info.uid)">
                        <div class="img">
                            <div class="boxImg">
                                <img :src="arr[0].user_info.avatar" alt="">
                            </div>
                            <div class="phone">
                                <img :src="require('../../assets/img/talent/no1phone.png')" alt="">
                            </div>
                            <div class="buyCount" v-if="arr[0].buy_count > 0">
                                {{arr[0].buy_count}}
                            </div>
                        </div>
                        <div class="text">
                            <p>{{arr[0].user_info.nickname}}</p>
                            <p>{{arr[0].text}}</p>
                        </div>
                        <div class="follow">
                            <span @click.stop="follow(arr[0].user_info.isFollowed, arr[2].user_info.uid)" :class="{followGuan:arr[0].user_info.isFollowed && arr[0].user_info.isFollowed  != 0}">{{!arr[0].user_info.isFollowed || arr[0].user_info.isFollowed == 0 ? '关注' : '已关注'}}</span>
                        </div>
                    </div>
                    <div class="three"  @click="goUserPage(arr[2].user_info.uid)">
                        <div class="img">
                            <div class="boxImg">
                                <img :src="arr[2].user_info.avatar" alt="">
                            </div>
                            <div class="phone">
                                <img :src="require('../../assets/img/talent/no3phone.png')" alt="">
                            </div>
                            <div class="buyCount" v-if="arr[2].buy_count > 0">
                                {{arr[2].buy_count}}
                            </div>
                        </div>
                        <div class="text">
                            <p>{{arr[2].user_info.nickname}}</p>
                            <p>{{arr[2].text}}</p>
                        </div>
                        <div class="follow">
                            <span @click.stop="follow(arr[2].user_info.isFollowed, arr[2].user_info.uid)" :class="{followGuan:arr[2].user_info.isFollowed && arr[2].user_info.isFollowed  != 0}">{{!arr[2].user_info.isFollowed || arr[2].user_info.isFollowed == 0 ? '关注' : '已关注'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main" v-if="arr">
            <div class="noRanking">
                <div class="item" v-for="(item, index) in arr.slice(3, arr.length)" :key="index" @click="goUserPage(item.user_info.uid)">
                    <div class="num">
                        {{4 + index}}
                    </div>
                    <div class="user">
                        <div class="left">
                            <div class="boxImg">
                                <div class="img">
                                    <img :src="item.user_info.avatar" alt="">
                                </div>
                                <div class="authorlevel" v-if="item.user_info.mp_rank">
                                    <img :src="require(`../../assets/img/talent/authorlevel${item.user_info.mp_rank}.png`)" alt="">
                                </div>
                                <div class="buyCount" v-if="item.buy_count > 0">
                                    {{item.buy_count}}
                                </div>
                            </div>
                            <div class="text">
                                <p>{{item.user_info.nickname}}</p>
                                <p>
                                    <span v-if="item.max_high_num >0 ">最长{{item.max_high_num}}连红</span>
                                </p>
                            </div>
                        </div>
                        <div class="right">
                            <span>{{item.text}}</span>
                        </div>
                    </div>
                    <div class="follow">
                        <span @click.stop="follow(item.user_info.isFollowed, item.user_info.uid)" :class="{followGuan: item.user_info.isFollowed && item.user_info.isFollowed  != 0}">{{!item.user_info.isFollowed || item.user_info.isFollowed  == 0 ? '关注' : '已关注'}}</span>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="show" round position="bottom" :style="{ height: '30%' }">
            <van-picker
                show-toolbar
                :columns="labelList[active]"
                @confirm="onConfirm"
                @cancel="show = false"
            />
        </van-popup>
    </div>
</template>

<script>
import { getHotListRank } from "../../api/api"
import { getQueryVariable, handleBannerPrams, isLogin, isJHAppAn } from "../../utils/base"
import { getUserFollow, getUserUnFollow } from "../../api/expert"
import { Toast } from "vant"
import jsbridg from "../../utils/jsbridg"
export default {
    name: "talent",
    data () {
        return {
            show: false,
            falg: false,
            sport_id: 0,
            active: 'high_num',
            activeLabel: {
                key: 'hit_high_num',
                text: '近期连红'
            },
            tabsList: [
                {
                    key: "high_num",
                    name: "连红"
                },
                {
                    key: "order_num",
                    name: "销量榜"
                },
                {
                    key: "return_rate",
                    name: "高回报"
                },
                {
                    key: "profit",
                    name: "盈利"
                },
                {
                    key: "several",
                    name: "战绩"
                }
            ],
            labelList: {
                high_num: [
                    {
                        key: 'hit_high_num',
                        text: '近期连红'
                    },
                    {
                        key: 'max_high_num',
                        text: '最长连红'
                    }
                ],
                order_num: [
                    {
                        key: 'order_num_3_days',
                        text: '近3天'
                    },
                    {
                        key: 'order_num_7_days',
                        text: '近7天'
                    },
                    {
                        key: 'order_num_30_days',
                        text: '近30天'
                    }
                ],
                return_rate: [
                    {
                        key: 'return_rate_10_sessions',
                        text: '近10场'
                    },
                    {
                        key: 'return_rate_7_days',
                        text: '近7天'
                    }
                ],
                profit: [
                    {
                        key: 'profit_num_20_days',
                        text: '近20天'
                    },
                    {
                        key: 'profit_num_3_days',
                        text: '近3天'
                    },
                    {
                        key: 'profit_num_7_days',
                        text: '近7天'
                    }
                ],
                several: [
                    {
                        key: 'hit_num_20_sessions',
                        text: '近20场'
                    },
                    {
                        key: 'hit_num_10_sessions',
                        text: '近10场'
                    },
                    {
                        key: 'hit_num_50_sessions',
                        text: '近50场'
                    }
                ]
            },
            arr: null
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        this.getList()
    },
    mounted () {
        // 隐藏客户端bar
        jsbridg.hideAppBar(0);
        window.addEventListener("scroll", this.topDom)
    },
    methods: {
        goUserPage (uid) {
            jsbridg.appUserPage(uid)
        },
        returnBack (status) {
            // android 1关闭 2返回
            if (isJHAppAn()) {
                if (status === 1) {
                    jsbridg.closeWebview();
                } else {
                    jsbridg.goBack();
                }
            } else {
                jsbridg.goBack();
            }
        },
        topDom () {
            const domTop = this.$refs.topRef.offsetTop
            if (window.pageYOffset > domTop) {
                this.falg = true
            } else {
                this.falg = false
            }
        },
        onConfirm (obj) {
            this.activeLabel = obj
            this.show = false
            this.getList()
        },
        async getList () {
            const params = {
                sport_id: this.sport_id,
                type: this.active,
                subtype: this.activeLabel.key
            }
            const res = await getHotListRank(params)
            if (res.errno === 0) {
                this.arr = res.data
            }
        },
        async follow (type, id) {
            if (isLogin()) {
                const src = getQueryVariable('src');
                const arr = handleBannerPrams(src);
                const params = {
                    version: arr[2],
                    channel: arr[1],
                    device: arr[0],
                    fuid: id,
                    src: src
                }
                // eslint-disable-next-line eqeqeq
                if (type == 0) {
                    const res = await getUserFollow(params)
                    if (res.errno === 0) {
                        Toast('关注成功');
                        this.getList()
                    } else {
                        Toast(res.errmsg);
                    }
                } else {
                    const res = await getUserUnFollow(params)
                    if (res.errno === 0) {
                        Toast('取关成功');
                        this.getList()
                    } else {
                        Toast(res.errmsg);
                    }
                }
            } else {
                jsbridg.jhAppLogin()
            }
        }
    }
}
</script>

<style lang="less" scoped>
.talent{
    .back{
        background: url("../../assets/img/talent/rankbackground.png") no-repeat;
        background-size: 100% 375px;
        position: relative;
        box-sizing: content-box;
        &::after{
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            left:0;
            top:0;
            background: rgba(0,0,0,.3);
            z-index: 1;
        }
        .blur{
            z-index: 10;
            position: relative;
        }
        .header{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
            background: rgba(255, 255, 255, 0.05);
            padding-top: 20px;
            span{
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                font-weight: 400;
                color: #FFFFFF;
                &:first-child{
                    justify-content: flex-start;
                    padding-left: 14px;
                    img{
                        width: 10px;
                        height: 18px;
                    }
                }
            }
        }
        .offsetTop{
            position: fixed;
            background: #fff;
            transition: all .5s;
            span{
                color: #000 !important;
            }
            top: 0;
            z-index: 100;
        }
        .seize{
            height: 70px;
        }
        .body{
            // background: rgba(255, 255, 255, 0.1);
            // filter: blur(10px);
            background: rgba(255, 255, 255, 0.05);
            .tabs{
                display: flex;
                justify-content: space-between;
                text-align: center;
                height: 25px;
                .item{
                    width: 70px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #FFFFFF;
                    display: flex;
                    justify-content: center;
                    position: relative;
                }
                .active{
                    &::before{
                        content: '';
                        position: absolute;
                        bottom: 0;
                        width: 18px;
                        height: 3px;
                        background: #FFFFFF;
                        border-radius: 1px;
                    }
                }
            }
            .label{
                display: flex;
                align-items: center;
                height: 50px;
                .left{
                    width: 80px;
                    font-size: 13px;
                    font-weight: 500;
                    color: #FFFFFF;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    span{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .right{
                    flex: 1;
                    display: flex;
                    justify-content: flex-end;
                    span{
                        width: 48px;
                        height: 24px;
                        border-radius: 12px;
                        border: 1px solid #FFFFFF;
                        font-size: 12px;
                        font-weight: 400;
                        color: #FFFFFF;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0 14px;
                    }
                    .btnActive{
                        border: 1px solid #FFFFFF;
                        background: #FFFFFF;
                        color: #169AFF;
                    }
                }
            }
        }
        .content{
            position: relative;
            z-index: 2;
            .ranking{
                padding: 12px 14px;
                display: flex;
                justify-content: center;
                align-items: flex-end;
                >div{
                    flex: 1;
                    height: 160px;
                    background: #FFFFFF;
                    border-radius: 5px;
                    .img{
                        height: 73px;
                        margin-top: 10px;
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        position: relative;
                        .boxImg{
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 50px;
                            width: 50px;
                            border: 1px solid;
                            border-radius: 50%;
                            overflow: hidden;
                            img{
                                height: 50px;
                                width: 50px;
                                object-fit: cover;
                            }
                        }
                        .phone{
                            position: absolute;
                            width: calc(187px / 2);
                            height: calc(62px / 2);
                            bottom: 0px;
                        }
                        .buyCount{
                            position: absolute;
                            top: 0;
                            right: calc(50% - 27px);
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            background: red;
                            font-size: 10px;
                            text-align: center;
                            line-height: 12px;
                            color: #fff;
                        }
                    }
                    .text{
                        p{
                            text-align: center;
                            &:first-child{
                                font-size: 12px;
                                font-weight: 400;
                                color: #333333;
                                margin: 3px 0;
                            }
                            &:last-child{
                                font-size: 12px;
                                font-weight: 600;
                                color: #FF5048;
                            }
                        }
                    }
                    .follow{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        span{
                            width: 49px;
                            height: 21px;
                            border-radius: 10px;
                            border: 1px solid #169AFF;
                            font-size: 10px;
                            font-weight: 400;
                            color: #169AFF;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-top: 5px;
                        }
                        .followGuan{
                            color: #999999;
                            border-color: #999999;
                        }
                    }
                }
                .one{
                    flex: none;
                    width: 135px;
                    height: 186px;
                    border-bottom-right-radius: 0px;
                    border-bottom-left-radius: 0px;
                    .text{
                        p{
                            &:first-child{
                                font-size: 16px;
                                font-weight: 400;
                                margin-top: 10px;
                            }
                            &:last-child{
                                font-size: 13px;
                                margin-top: 5px;
                                color: #FF5048;
                            }
                        }
                        margin-bottom: 8px;
                    }
                    .img{
                        .boxImg{
                            border-color: #ffd24e;
                        }
                    }
                }
                .two{
                    border-top-right-radius: 0px;
                    border-bottom-right-radius: 0px;
                    .img{
                        .boxImg{
                            border-color: #4CA3FE;
                        }
                    }
                }
                .three{
                    border-top-left-radius: 0px;
                    border-bottom-left-radius: 0px;
                    .img{
                        .boxImg{
                            border-color: #F19B4F;
                        }
                    }
                }
            }
        }
    }
     .main{
        .noRanking{
            .item{
                height: 60px;
                border-bottom:1px solid #EEEEEE;
                display: flex;
                justify-content: space-between;
                >div{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .num{
                    width: 40px;
                    font-size: 15px;
                    font-weight: 400;
                    color: #333333;
                }
                .user{
                    flex: 1;
                    justify-content: space-between;
                    .left{
                        flex: 1;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        .boxImg{
                            width: 35px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            .img{
                                width: 35px;
                                height: 35px;
                                border-radius: 50%;
                                overflow: hidden;
                                img{
                                    width: 35px;
                                    height: 35px;
                                    object-fit: cover;
                                }
                            }
                            .authorlevel{
                                position: absolute;
                                bottom: 0;
                                right: 0;
                                width: calc(56px / 4);
                                height: calc(64px / 4);
                            }
                            .buyCount{
                                position: absolute;
                                top: 0;
                                right: 0;
                                width: 12px;
                                height: 12px;
                                border-radius: 50%;
                                background: red;
                                font-size: 10px;
                                text-align: center;
                                line-height: 12px;
                                color: #fff;
                            }
                        }
                        .text{
                            margin-left: 4px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            p{
                                &:first-child{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #333333;
                                    margin-bottom: 5px;
                                }
                                &:last-child{
                                    display: flex;
                                    justify-content: flex-start;
                                    align-items: center;
                                    // height: 15px;
                                    span{
                                        height: 13px;
                                        border-radius: 2px;
                                        border: 1px solid #FF5048;
                                        padding: 0 5px;
                                        font-size: 10px;
                                        font-weight: 400;
                                        color: #FF5048;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        margin-right: 5px;
                                    }
                                }
                            }
                        }
                    }
                    .right{
                        width: 55px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        span{
                            font-size: 12px;
                            font-weight: 600;
                            color: #FF5048;
                        }
                    }
                }
                .follow{
                    width: 83px;
                    span{
                        width: 57px;
                        height: 25px;
                        border-radius: 13px;
                        border: 1px solid #169AFF;
                        font-size: 12px;
                        font-weight: 400;
                        color: #169AFF;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .followGuan{
                        color: #999999;
                        border-color: #999999;
                    }
                }
            }
        }
    }
}
.talentDark{
    min-height: 100vh;
    background-color: #191919;
    .back{
        background-image: url("../../assets/img/talent/rankbackgroundDark.png");
        .header{
            span{
                color: #d3d3d3;
            }
        }
        .offsetTop{
            background-color: #191919;
            span{
                color: #d3d3d3 !important;
            }
        }
        .body{
            .tabs{
                .item{
                    color: #d3d3d3;
                }
                .active{
                    &::before{
                        content: '';
                        position: absolute;
                        bottom: 0;
                        width: 18px;
                        height: 3px;
                        background: #0091FF;
                        border-radius: 1px;
                    }
                }
            }
            .label{
                .left{
                    color: #d3d3d3;
                }
                .right{
                    span{
                        border-color: #d3d3d3;
                        color: #d3d3d3;
                    }
                    .btnActive{
                        border-color: #169AFF;
                        background: #191919;
                        color: #169AFF;
                    }
                }
            }

        }
        .content{
            .ranking{
                >div{
                    background-color: #232323;
                    .text{
                        p{
                            &:first-child{
                                color: #d3d3d3;
                            }
                        }
                    }
                    .follow{
                        .followGuan{
                            color: #595959;
                            border-color: #595959;
                        }
                    }
                }
            }
        }
    }
    .main{
        .noRanking{
            .item{
                border-color: #232323;
                .num{
                    color: #d3d3d3;
                }
                .user{
                    .left{
                        .text{
                            p{
                                &:first-child{
                                    color: #d3d3d3;
                                }
                            }
                        }
                    }
                }
                .follow{
                    .followGuan{
                        color: #595959;
                        border-color: #595959;
                    }
                }
            }
        }
    }
    /deep/.van-popup{
        background-color: #191919;
    }
    /deep/.van-picker{
        background-color: #191919;
        .van-picker__mask{
            background-image: none
        }
        .van-picker-column__item{
            color: #d3d3d3;
        }
        .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
            border-color: #2f2f2f;
        }
    }
}
</style>
